module.exports = __webpack_public_path__ + "static/img/casetoop.39607c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/casetoop.jpg
// module id = jwzE
// module chunks = 1